import { IconFont, BasTitle } from '@/components'
import { Modal, Table } from 'antd'
import styled from 'styled-components'
import React from 'react'
import { render } from 'react-dom'
import { t } from '@/i18n'

interface PropsType {
  open: boolean
  dataSource: DataItemType[]
  loading?: boolean
  onClose: () => void
  handleDelete: (id: string) => void
}

export interface DataItemType {
  //  是否支持删除
  canDelete?: boolean
  //  设备品牌
  deviceBrand?: string
  //  设备IP
  deviceIp?: string
  //  设备类型
  deviceType?: string
  //  失败数量
  failureTotal?: number
  //  导入记录id
  id?: string
  //  导入时间
  importedTime?: string
  //  成功数量
  successTotal?: number
  [property: string]: any
}

export const RecordModal: React.FC<PropsType> = ({
  open,
  dataSource,
  onClose,
  handleDelete,
  loading,
}) => {
  const columns = [
    {
      width: '1%',
    },
    {
      title: t('设备类型'),
      dataIndex: 'deviceType',
    },
    {
      title: t('设备IP'),
      dataIndex: 'deviceIp',
    },
    {
      title: t('导入时间'),
      dataIndex: 'importedTime',
      render: text => <span>{new Date(text).toLocaleString()}</span>,
    },
    {
      title: t('导入数量'),
      render: (_, { successTotal, failureTotal }) => (
        <>
          <span style={{ color: '#00B42A', marginRight: '4px' }}>{successTotal}</span>|
          <span style={{ color: '#F53F3F', marginLeft: '4px' }}>{failureTotal}</span>
        </>
      ),
    },
    {
      title: t('操作'),
      render: (_, { canDelete, id }) => (
        <div
          style={{
            color: canDelete ? '#4238c9' : '#999',
            cursor: canDelete ? 'pointer' : 'not-allowed',
          }}
          onClick={() => {
            if (canDelete) {
              handleDelete(id)
            }
          }}
        >
          <IconFont type="icon-shanchu-m" style={{ marginRight: '8px' }} />
          <span>{t('删除')}</span>
        </div>
      ),
    },
  ]

  return (
    <ResultModal
      width={700}
      title={<BasTitle title={t('离线日志导入结果')} />}
      open={open}
      onCancel={onClose}
      footer={null}
      style={{ minHeight: '400px' }}
      centered
    >
      <Table
        columns={columns}
        pagination={false}
        dataSource={dataSource}
        loading={loading || false}
      />
    </ResultModal>
  )
}

const ResultModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 8px;
    position: relative;

    .ant-modal-close {
      width: 36px;
      height: 36px;
      background: #d8d6f4;
      box-shadow: -1px 4px 10px 0px #c7c7c7;
      border-radius: 6px;
      border: none;
      color: #4238c9;
      font-size: 16px;
      font-weight: 500;
      position: absolute;
      right: -8px;
      top: -8px;
      transition: transform 0.3s ease;

      &:hover {
        transform: translate(-18px, 18px);
        box-shadow: 0 0 0 0;
      }

      .ant-modal-close-x {
        width: 100%;
        height: 100%;
        line-height: 36px;
        text-align: center;
      }
    }

    .ant-modal-header {
      height: 56px;
      background: #f2f0ff;
      border-bottom: none;
      margin: 0;
    }
  }
  .ant-modal-body {
    min-height: 340px;
  }
`
